export enum UserRole {
  Client,
  Admin
}
